import { DEFAULT_FLOW_ORIGIN, validateFlowUrl } from '@coopercarga/flow-chat/origin';

// Configuração do Flow Chat. Contrato do pacote e regras em docs/integrations/flow-chat.md.

// Estágios em que VITE_FLOW_CHAT_URL pode apontar para outro Flow. Produção (ou estágio
// desconhecido) só aceita o Flow oficial: o guia do pacote proíbe allowCustomFlowOrigin em prod.
const STAGES_WITH_CUSTOM_FLOW = ['dev', 'homol', 'test'];

// Lidas por extenso: os testes trocam cada import.meta.env.VITE_* pelo `define` do Vite.
const ENV = {
  enabled: import.meta.env.VITE_FLOW_CHAT_ENABLED,
  url: import.meta.env.VITE_FLOW_CHAT_URL,
  stage: import.meta.env.VITE_STAGE,
};

const DISABLED = { enabled: false, flowUrl: undefined, allowCustomFlowOrigin: false };

/**
 * Props de configuração do FlowChatLauncher. URL inválida desliga o assistente com um aviso,
 * em vez de deixar o mount do pacote lançar TypeError e derrubar a página.
 */
export function getFlowChatConfig({ enabled, url, stage } = ENV) {
  if (enabled !== 'true') return DISABLED;
  if (!url) return { enabled: true, flowUrl: undefined, allowCustomFlowOrigin: false };

  const result = validateFlowUrl(url, {
    allowCustomFlowOrigin: STAGES_WITH_CUSTOM_FLOW.includes(stage),
  });
  if (!result.ok) {
    console.warn(`Flow Chat desligado: VITE_FLOW_CHAT_URL inválida (${result.reason}).`);
    return DISABLED;
  }
  return {
    enabled: true,
    flowUrl: result.url,
    allowCustomFlowOrigin: result.origin !== DEFAULT_FLOW_ORIGIN,
  };
}
